import React, { useState } from "react";
import classes from "./RowOptionsOverlay.scss";
import { Dialog, IconButton, Tooltip } from "@toddle-edu/ds-web";
import { AddRowOutlined, DeleteOutlined } from "@toddle-edu/ds-icons";
import { elevations } from "@toddle-edu/ds-theme";
import PropTypes from "prop-types";

// component to add rows to left or right, or delete rows.
const RowOptionsOverlay = React.memo(
  ({ deleteRow, id, index, addRow, addRowDisabled, t, testId }) => {
    const addRowBefore = () => addRow(index);
    const addRowAfter = () => addRow(index + 1);
    const deleteRowIndex = () => deleteRow(id);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const toggleDeleteDialog = () => {
      setShowDeleteDialog(!showDeleteDialog);
    };

    return (
      <div className={classes.container} style={elevations["elevation-2B"]}>
        <Tooltip
          tooltip={t("common:label_count", {
            count: t("worksheet:add_row"),
            label: t("worksheet:after"),
          })}
        >
          <IconButton
            icon={<AddRowOutlined variant={"subtle"} />}
            variant="subtle"
            onMouseDown={addRowAfter}
            disabled={addRowDisabled}
            size="small"
            testId={`${testId}-RowOptionsOverlay-AddRowAfter`}
          ></IconButton>
        </Tooltip>
        <Tooltip
          tooltip={t("common:label_count", {
            count: t("worksheet:add_row"),
            label: t("worksheet:before"),
          })}
        >
          <IconButton
            icon={<AddRowOutlined variant={"subtle"} />}
            variant="subtle"
            // same icon rotated 180deg
            className={classes.reverseX}
            onMouseDown={addRowBefore}
            disabled={addRowDisabled}
            size="small"
            testId={`${testId}-RowOptionsOverlay-AddRowBefore`}
          ></IconButton>
        </Tooltip>
        <div className={classes.divider} />
        <Tooltip tooltip={t("worksheet:delete_row")}>
          <IconButton
            icon={<DeleteOutlined variant={"subtle"} />}
            variant="subtle"
            onMouseDown={toggleDeleteDialog}
            size="small"
            testId={`${testId}-RowOptionsOverlay-DeleteRow`}
          ></IconButton>
        </Tooltip>
        {showDeleteDialog ? (
          <Dialog
            title={t("common:delete_with_label", {
              label: t(`common:row`),
            })}
            message={t("common:this_action_cannot_be_undone")}
            buttonOneText={t("common:cancel")}
            buttonTwoText={t("common:delete")}
            onButtonOneClick={toggleDeleteDialog}
            onButtonTwoClick={deleteRowIndex}
            isClosable={true}
            onClose={toggleDeleteDialog}
            testId={`${testId}-RowOptionsOverlay-DeleteDialog`}
          />
        ) : null}
      </div>
    );
  }
);

RowOptionsOverlay.displayName = "RowOptionsOverlay";

RowOptionsOverlay.propTypes = {
  deleteRow: PropTypes.func,
  addRow: PropTypes.func,
  index: PropTypes.number,
  addRowDisabled: PropTypes.bool,
  testId: PropTypes.string,
};
export default RowOptionsOverlay;
